import { render, staticRenderFns } from "./IconAdd.vue?vue&type=template&id=7a173e7c"
import script from "./IconAdd.vue?vue&type=script&lang=js"
export * from "./IconAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports